import React, { Suspense, lazy } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { shallowEqual, useSelector } from "react-redux";
import * as TYPE from './lib/contrant'


const UserProfilepage = lazy(() =>
  import("./modules/UserProfile/UserProfilePage")
);

const Dashboard = lazy(() =>
  import("./pages/Dashboard")
);

const ListUserAdmin = lazy(() =>
  import("./pages/Admin/ListUserAdmin")
);
const ListTask = lazy(() =>
  import("./pages/Task/ListTask")
);
const ListUserClient = lazy(() =>
  import("./pages/User/ListUser")
);
const HistoryWallet = lazy(() =>
  import("./pages/User/HistoryWallet")
);
const ListUser = lazy(() =>
  import("./pages/User/ListUser")
);

const UserProfile = lazy(() =>
  import("./pages/User/UserProfile")
);

const ListTeam = lazy(() =>
  import("./pages/LeaderBoard/ListTeam")
)

const DetailTeam = lazy(() =>
  import("./pages/LeaderBoard/DetailTeam")
)

const ChangePassword = lazy(() =>
  import("./pages/User/ChangePassword")
);

const AdminProfile = lazy(() =>
  import("./pages/User/AdminProfile")
);

const AssetsManagement = lazy(() =>
  import("./pages/Assets/AssetsManagement")
);

const HistoryManagement = lazy(() =>
  import("./pages/Assets/HistoryManagement")
);

const DailyCodeManagement = lazy(() =>
  import("./pages/DailyCode/DailyCodeManagement")
);

const CompletedDailyCodeList = lazy(() =>
  import("./pages/DailyCode/DailyCodeCompletedList")
);

const CompletedDailyCodeListDetail = lazy(() =>
  import("./pages/DailyCode/DailyCodeCompletedListDetail")
);

const ConfigureProgram = lazy(() =>
  import("./pages/LuckyMoney/ConfigureProgram")
)
const LuckyHistory = lazy(() => import("./pages/LuckyMoney/LuckyHistory"));

const GroupTaskManagement = lazy(() => import("./pages/GroupTask"))

const TapConfig = lazy(() =>
  import("./pages/Config/TapConfig")
);

const FarmConfig = lazy(() =>
  import("./pages/Config/FarmConfig")
);

const TonAddress = lazy(() => import("./pages/Config/TonAddress"));
const RewardPrizecConfig = lazy(() => import("./pages/Config/RewardPrizecConfig"));

const ListUserCheckin = lazy(() =>
  import("./pages/Checkin/ListUserCheckin")
);

const DetailUserCheckin = lazy(() =>
  import("./pages/Checkin/DetailUserCheckin")
);

const CheckinConfig = lazy(() =>
  import("./pages/Checkin/CheckinConfig")
);

export default function BasePage() {
  const { listUserLoginPermission } = useSelector(state => ({
    listUserLoginPermission: state.authReducer.listUserLoginPermission,
  }), shallowEqual)

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        {/* Trang chủ */}
        <Route path="/dashboard" component={Dashboard} exact />
        {/* end */}

        <Route path="/user-profile" component={UserProfilepage} exact />
        {<Route path="/assets/list" component={AssetsManagement} exact />}
        {<Route path="/history/:id" component={HistoryManagement} exact />}
        {/* Quản lý người dùng */}
        {<Route path="/admin/list-user" component={ListUserAdmin} exact />}
        {<Route path="/task/list" component={ListTask} exact />}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) && <Route path="/user/list-user" component={ListUser} exact />}
        <Route path="/user/profile/:id" component={UserProfile} exact />
        {<Route path="/team/list" component={ListTeam} exact />}
        {<Route path="/team/:id" component={DetailTeam} exact />}
        <Route
          path="/lucky-draw/list"
          component={ConfigureProgram}
        />
        <Route
          path="/lucky-draw/history/:configureProgramId"
          component={LuckyHistory}
        />
        {/* Quản lý người chơi */}
        {<Route path="/user/list" component={ListUserClient} exact />}
        {<Route path="/user/wallet" component={HistoryWallet} exact />}
        {/* end */}

        {/* Quản lý admin */}
        {listUserLoginPermission.includes(TYPE.DOI_MAT_KHAU) && <Route path="/admin/change-password" component={ChangePassword} exact />}
        {listUserLoginPermission.includes(TYPE.TRANG_CA_NHAN_ADMIN) && <Route path="/admin/profile" component={AdminProfile} exact />}
        {/* end */}

        {/* Quản lý mật mã ngày */}
        <Route path="/daily-code/list" component={DailyCodeManagement} exact />
        <Route path="/daily-code/completed" component={CompletedDailyCodeList} exact />
        <Route path="/daily-code/completed/detail/:date" component={CompletedDailyCodeListDetail} exact />
        {/* end */}

        {/* Quản lý nhóm nhiệm vụ */}
        <Route path="/task/group" component={GroupTaskManagement} exact />

        {<Route path="/config/tap" component={TapConfig} exact />}
        {<Route path="/config/farm" component={FarmConfig} exact />}

        {<Route path="/checkin/list" component={ListUserCheckin} exact />}
        {<Route path="/checkin/setting" component={CheckinConfig} exact />}
        {<Route path="/checkin/:id" component={DetailUserCheckin} exact />}

        <Route path="/config/address-ton" component={TonAddress} exact />
        <Route path="/config/reward-prize" component={RewardPrizecConfig} exact />

        <Redirect from="/login" to="/" />
      </Switch>
    </Suspense>
  );  
}
